import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MobileService {
  isMobile(): boolean {
    return window.innerWidth <= 576;
  }

  isDesktop(): boolean {
    return window.innerWidth > 1028;
  }

  getDisplayedCardsPerRow(): number {
    if (window.innerWidth <= 576) return 1;
    if (window.innerWidth <= 867) return 2;
    if (window.innerWidth <= 1199) return 3;
    return 4;
  }
}
